/**
 * @generated SignedSource<<e7dca039c9ced47eb2026a1e22e10ff7>>
 * @relayHash c3353f84d926e53d182a7ef45d21f851
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 42516e8cdc4d8b41051ddf86c34fff50012d3cbb140d58a0d9283f9d09cb2d94

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type aquaEmailLogsQuery$variables = {
  cloudId: string;
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  notificationActionType?: string | null | undefined;
  notificationType?: string | null | undefined;
  projectId?: AGG$Long | null | undefined;
};
export type aquaEmailLogsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable">;
};
export type aquaEmailLogsQuery = {
  response: aquaEmailLogsQuery$data;
  variables: aquaEmailLogsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": 20,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "notificationActionType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "notificationType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "aquaEmailLogsQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          }
        ],
        "kind": "FragmentSpread",
        "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "aquaEmailLogsQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "AquaOutgoingEmailLogsQueryApi",
        "kind": "LinkedField",
        "name": "aquaOutgoingEmailLogs",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "notificationActionType",
                "variableName": "notificationActionType"
              },
              {
                "kind": "Variable",
                "name": "notificationType",
                "variableName": "notificationType"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              }
            ],
            "kind": "LinkedField",
            "name": "GetNotificationLogs",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v2/*: any*/),
                    "concreteType": "AquaOutgoingEmailLogConnection",
                    "kind": "LinkedField",
                    "name": "logs",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AquaOutgoingEmailLogItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "AquaOutgoingEmailLogItem",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "AquaIssueContext",
                                "kind": "LinkedField",
                                "name": "issueContext",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "key"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "webUrl"
                                      },
                                      (v3/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "notificationActionType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "actionTimestamp"
                              },
                              {
                                "concreteType": "AquaNotificationDetails",
                                "kind": "LinkedField",
                                "name": "notificationDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "errorKey"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "mailboxMessage"
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "recipient",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "email"
                                      }
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "name"
                                      }
                                    ],
                                    "type": "CustomerUser"
                                  },
                                  (v3/*: any*/)
                                ]
                              },
                              (v1/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "startCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasPreviousPage"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "args": (v2/*: any*/),
                    "handle": "connection",
                    "key": "aquaOutgoingEmail__logs",
                    "kind": "LinkedHandle",
                    "name": "logs"
                  }
                ],
                "type": "AquaOutgoingEmailLog"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "42516e8cdc4d8b41051ddf86c34fff50012d3cbb140d58a0d9283f9d09cb2d94",
    "metadata": {},
    "name": "aquaEmailLogsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ce3f76d0fe1ca275bccfadfeb21cb8d7";

export default node;
